import { ClassTransformOptions, instanceToPlain } from "class-transformer";

const defaultDateSerializer = (value: Date) => JSON.stringify(value.toISOString());
const defaultArraySerializer = (value: unknown[]) => JSON.stringify(value);
const defaultObjectSerializer = (value: Record<string, unknown>) => JSON.stringify(value);
const defaultNumberSerializer = (value: number) => JSON.stringify(value);
const defaultSerializer = (value: unknown) => JSON.stringify(value);

export type CreateFormDataOptions = {
	dateSerializer?: (value: Date) => string;
	arraySerializer?: (value: unknown[]) => string;
	objectSerializer?: (value: Record<string, unknown>) => string;
	numberSerializer?: (value: number) => string;
	classTransformOptions?: ClassTransformOptions;
};

/**
 * Create a FormData object from a given object.
 */
export const createFormData = <T>(object: T, options?: CreateFormDataOptions): FormData => {
	const formData = new FormData();

	Object.entries(instanceToPlain(object, options?.classTransformOptions))
		.filter(([_, value]) => value !== undefined)
		.forEach(([key, value]) => {
			switch (true) {
				case value instanceof Date:
					formData.append(key, (options?.dateSerializer ?? defaultDateSerializer)(value));
					break;
				case value instanceof File:
					formData.append(key, value);
					break;
				case Array.isArray(value):
					formData.append(key, (options?.arraySerializer ?? defaultArraySerializer)(value));
					break;
				case typeof value === "object" && value !== null:
					formData.append(key, (options?.objectSerializer ?? defaultObjectSerializer)(value as Record<string, unknown>));
					break;
				case typeof value === "number":
					formData.append(key, (options?.numberSerializer ?? defaultNumberSerializer)(value as number));
					break;
				default:
					formData.append(key, defaultSerializer(value));
					break;
			}
		});

	return formData;
};
